/**
 * @desc 获取详情
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysUserLoginLog/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
